/**
 * Used in showing the actual id of each product, so the users don't have to see
 * the string attached to each when created
 * @param productId
 */
export const getActualProductId = (productId = '') =>
  parseInt(productId.split('product:')[1], 10)

/**
 * this simply attach the desired product code to the entered id
 */
export const makeProductId = id => 'product:' + id

/**
 * used to check if the product id is a valid product id or not
 * @param id
 * @return boolean
 */
export const isValidProductId = id => id.toString().includes('product:')

/**
 * this is just to sort our products by the id
 * @param {*} entity
 */
export const sortById = entity => {
  return entity.sort(
    (entity1, entity2) =>
      getActualProductId(entity1._id) > getActualProductId(entity2._id) ? 1 : -1
  )
}



// WEBPACK FOOTER //
// ./src/products/id-handler.js